import { INewOrder } from "../../../Models/Order/INewOrder";
import { IResult } from "../../../Models/Result/IResult";
import { IOrderApi } from "./IOrderApi";
import axios from 'axios';
import { formatUrl, handleError } from "../ApiHelpers";
import { IOrder } from "../../../Models/Order/IOrder";
import { OrderStateEnum } from "../../../Models/Order/OrderStateEnum";
import { IOrderListItem } from "../../../Models/Order/IOrderListItem";
import { Result } from "../../../Models/Result/Result";
import { dateToStr, strToDate } from "../../../Tools/DateTime";

export class OrderApi implements IOrderApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getOrdersList(orderId?: number, state?: OrderStateEnum, name?: string, eventName?: string, onlyUnfinished?: boolean, userId?: string): Promise<IResult<IOrderListItem[]>> {
        try {
            let url = formatUrl(this.backendUrl, `/api/Order/GetOrdersList`);
            let ad = "?";
            if (orderId) {
                url = url + ad + `orderId=${orderId}`
                ad = "&";
            }
            if (state) {
                url = url + ad + `state=${state}`
                ad = "&";
            }
            if (onlyUnfinished===true) {
                url = url + ad + `onlyUnfinished=true`
                ad = "&";
            }

            if (name) {
                url = url + ad + `name=${name}`
                ad = "&";
            }
            if (eventName) {
                url = url + ad + `eventName=${eventName}`
                ad = "&";
            }
            if (userId) {
                url = url + ad + `userId=${userId}`
                ad = "&";
            }
            const response = await axios.get(url);
            const r = (response.data as IResult<IOrderListItem[]>).data?.map(item => {
                item.created = strToDate(item.created.toString()); 
                return item;
            });
            return Result.ok(r??[]);
        }
        catch (error) {
            return handleError(error, "newOrder");
        }
    }

    async getOrder(orderId: number): Promise<IResult<IOrder>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Order/GetOrder/${orderId}`);
            const response = await axios.get(url);
            return response.data as IResult<IOrder>;
        }
        catch (error) {
            return handleError(error, "newOrder");
        }
    }

    async newOrder(order: INewOrder): Promise<IResult<number>> {
        try {
            const o = {
                ...order, Attendees: [...order.Attendees.map(item => {
                    const a = { ...item };
                    a.dateOfBirth = dateToStr(item.dateOfBirth as Date);
                    return a;
                })]
            }
            const url = formatUrl(this.backendUrl, `/api/Order/NewOrder`);
            const response = await axios.post(url, o);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "newOrder");
        }
    }

    async changeOrderState(orderId: number, state:OrderStateEnum): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Order/ChangeOrderState/${orderId}?state=${state}`);
            const response = await axios.post(url);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "changeOrderState");
        }
    }

}